import React, { useEffect } from 'react'
import { InfoPill } from '../../../../elementals'
import { ColorNames } from '../../../../../constants'
import classnames from 'classnames/bind'
// @ts-ignore no types
import styles from '../styles.scss'

const cx = classnames.bind(styles)

interface BidRankActionPillProps {
  isMobile?: boolean
  action: string
  duration?: number
  onTimeout?: () => void
}

const BidRankActionPill: React.FC<BidRankActionPillProps> = ({
  isMobile,
  action,
  duration,
  onTimeout,
}) => {
  useEffect(() => {
    if (!duration || !onTimeout) {
      return
    }
    const timer = setTimeout(() => {
      onTimeout()
    }, duration)

    return () => {
      clearTimeout(timer)
    }
  }, [])

  return (
    <InfoPill
      className={cx('action-pill')}
      size={isMobile ? 'small' : 'medium'}
      content={action}
      backgroundColor={ColorNames.InfoExtraLight}
      foregroundColor={ColorNames.Info}
      includeBorder
    />
  )
}

export default BidRankActionPill
